import { MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";

/*
 * Lo común de los diálogos de pruebas (T2 «Registrar ejecución», «Crear
 * incidencia» y «Vincular incidencia»): la forma de los diálogos estándar
 * (app-standard-dialog y la caja .app-dialog de styles.css, debajo de la
 * barra superior fija, como T1) y el cierre con Escape o con clic fuera, que
 * pasa por el «Cancelar» del diálogo para que no se cierre a mitad de un
 * guardado.
 */

/** La configuración de MatDialog para un diálogo de pruebas. */
export function configDialogoPruebas<D>(datos: D, idTitulo: string, ancho: string): MatDialogConfig<D> {
  return {
    data: datos,
    width: ancho,
    maxWidth: "calc(100vw - 32px)",
    maxHeight: "calc(100vh - 106px)",
    position: { top: "90px" },
    panelClass: "app-standard-dialog",
    backdropClass: "app-standard-dialog-backdrop",
    ariaLabelledBy: idTitulo,
    autoFocus: "dialog",
    disableClose: true,
  };
}

/** Escape y el clic fuera del cuadro llaman a cancelar (que decide si se puede cerrar). */
export function cierrePorTeclaOFondo(ref: MatDialogRef<unknown, unknown>, cancelar: () => void): Subscription[] {
  return [
    ref.backdropClick().subscribe(() => cancelar()),
    ref.keydownEvents().subscribe((evento) => {
      if (evento.key === "Escape") {
        evento.preventDefault();
        cancelar();
      }
    }),
  ];
}
